import { Box, Button, CircularProgress, Typography } from '@mui/material';
import doneGIF from '../../../assets/done.gif';
import { ReactComponent as GreenCheckFilled } from '../../../assets/green-check-filled.svg';
import { ConfirmButton } from '../components/Buttons';

function ActionBar({
  onBack,
  hasBackAction,
  onNext,
  onOpenGeneratePreviewModal,
  onSubmit,
  hasSubmitAction,
  isSubmitting,
  errorMessage,
  isSaving,
  showSaved,
}) {
  const backButton = hasBackAction ? (
    <Button
      variant="text"
      sx={{
        borderRadius: 6,
        color: '#3B6CAB',
        textTransform: 'none',
        fontWeight: 600,
        height: 40,
        width: 85,
      }}
      onClick={onBack}>
      Back
    </Button>
  ) : (
    <></>
  );

  const nextButton = hasSubmitAction ? (
    <ConfirmButton
      label="Submit"
      sx={{ minWidth: 145, minHeight: 40 }}
      onClick={onSubmit}
      isLoading={isSubmitting}
    />
  ) : (
    <ConfirmButton label="Next" sx={{ minWidth: 145, minHeight: 40 }} onClick={onNext} />
  );

  const generateSurveyPreviewButton = (
    <Button
      variant="outlined"
      sx={{
        borderRadius: 6,
        color: '#3B6CAB',
        textTransform: 'none',
        fontWeight: 600,
        height: 40,
        whiteSpace: 'nowrap',
      }}
      onClick={onOpenGeneratePreviewModal}>
      Generate Survey Preview
    </Button>
  );

  const renderSavingIndicator = () => {
    const savingIcon = () => {
      if (isSaving) {
        return (
          <>
            <CircularProgress size={16} sx={{ marginX: 0.5, color: '#10203d' }} />
            <Typography variant="body2" sx={{ color: '#878787' }}>
              Saving...
            </Typography>
          </>
        );
      }

      if (showSaved) {
        return (
          <>
            <img style={{ width: 24, height: 24 }} src={doneGIF} alt="saved" />
            <Typography variant="body2" sx={{ color: '#878787' }}>
              Saved!
            </Typography>
          </>
        );
      }

      return <GreenCheckFilled />;
    };

    return (
      <Box display="flex" alignItems="center" gap={1}>
        {savingIcon()}
      </Box>
    );
  };

  return (
    <Box display="flex" justifyContent="space-between" gap={2} height="100%" alignItems="center">
      <Box>{renderSavingIndicator()}</Box>
      {!isSaving && !showSaved && hasSubmitAction && errorMessage && (
        <Box>
          <Typography sx={{ fontSize: '12px', color: '#EE404C' }}>{errorMessage}</Typography>
        </Box>
      )}
      <Box display="flex" gap={1}>
        {backButton}
        {hasSubmitAction && generateSurveyPreviewButton}
        {nextButton}
      </Box>
    </Box>
  );
}

export default ActionBar;
